export default "__VITE_ASSET__5cdd5433__"